var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeGames(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_30282)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.125 9a.374.374 0 01-.26-.104L9.5.894 1.134 8.896a.375.375 0 01-.519-.542L9.24.104a.376.376 0 01.52 0l8.624 8.25a.375.375 0 01-.26.646zm-2.25 9H3.125a.375.375 0 01-.375-.375v-8.25a.375.375 0 01.75 0v7.875h12V9.375a.375.375 0 01.75 0v8.25a.375.375 0 01-.375.375zM8.486 8.904a.154.154 0 01-.147.103h-2.7c-.185 0-.263.23-.113.335l2.184 1.54a.15.15 0 01.056.168l-.833 2.49c-.058.172.143.314.294.208l2.182-1.54a.16.16 0 01.181 0l2.183 1.54c.15.106.352-.036.295-.207l-.835-2.491a.15.15 0 01.056-.167l2.184-1.54c.15-.107.072-.336-.113-.336h-2.698a.153.153 0 01-.147-.103l-.834-2.49c-.057-.172-.306-.172-.363 0l-.832 2.49z",
    fill: "#999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_30282"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h18v18H0z"
  })))));
}
SvgHomeGames.displayName = 'HomeGames';
export default SvgHomeGames;